var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('AppIcon',{attrs:{"name":"angle-down"}}),_c('AppIcon',{attrs:{"name":"search"}}),_c('AppIcon',{attrs:{"name":"twitter"}}),_c('AppIcon',{attrs:{"name":"github"}}),_c('AppIcon',{attrs:{"name":"youtube"}}),_c('AppIcon',{attrs:{"name":"discord"}}),_c('AppIcon',{attrs:{"name":"medium-m"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }